
import { Component, Prop, Vue } from "vue-property-decorator";
import copy from "copy-to-clipboard";
import { ISMSForm } from "@/models/SMS";
import { TInputRule } from "@nationbetter/nb-components/src/models/Input";

@Component({
  components: {
    HorizontalStepperLabel: () => import("../elements/HorizontalStepperLabel.vue"),
    HorizontalStepperLabelStep: () => import("../elements/HorizontalStepperLabelStep.vue"),
  },
})
export default class StepTwoSMS extends Vue {
  @Prop({ type: Object, required: true }) readonly form!: ISMSForm;

  tooltip = "Copy";

  setStep(step: number) {
    this.$emit("setStep", step);
  }

  copyToClipboard(text: string) {
    copy(text);
  }

  rules: TInputRule[] = [(v) => !!v || "Required"];

  get isFormValid() {
    return !!(
      this.form.number_of_employees_change_reason && this.form.number_of_employees_change_details
    );
  }
}
